module.exports = __webpack_public_path__ + "static/img/logo2.4beeca18.png";